import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../components/helpers/Navbar";
import AtribuirePuncte from "./PRDP Membri/AtribuirePuncte";
import ListaMembriPunctaj from "./PRDP Membri/ListaMembriPunctaj";
import CereriPuncte from "./PRDP Membri/CereriPuncte";
import CreeazaCursuri from "./PRDP Membri/CreeazaCursuri";
import CreeazaEveniment from "./PRDP Membri/CreeazaEveniment";
import AdminEditCursuri from "./PRDP Membri/EditeazaCursuri";
import ModificareStatusMembru from "./PRDP Membri/ModificareStatusMembru";
import AdminProiecteNeaprobate from "./PRDP Membri/AdminProiecte";

export default function PRDPMembriPage() {
  const [activeTab, setActiveTab] = useState("cereri");

  const renderContent = () => {
    switch (activeTab) {
      case "cereri":
        return <CereriPuncte />;
      case "atribuire":
        return <AtribuirePuncte />;
      case "proiecte":
        return <AdminProiecteNeaprobate />;
      case "membri":
        return <ListaMembriPunctaj/>;
      case "status":
        return <ModificareStatusMembru />;
      case "eveniment":
        return <CreeazaEveniment />;
      case "cursuri":
        return <CreeazaCursuri />;
      case "editeazaCursuri":
        return <AdminEditCursuri />    
      default:
        return <h4>Bun venit în dashboard</h4>;
    }
  };

  return (
    <>
    <Navbar />
        <div className="container mt-3">
        {/* Navbar secundar */}
        <ul className="nav nav-tabs nav-prdp-membri-page">
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "cereri" ? "active" : ""}`}
                onClick={() => setActiveTab("cereri")}
            >
                Cereri puncte
            </button>
            </li>
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "atribuire" ? "active" : ""}`}
                onClick={() => setActiveTab("atribuire")}
            >
                Atribuire puncte
            </button>
            </li>
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "proiecte" ? "active" : ""}`}
                onClick={() => setActiveTab("proiecte")}
            >
                Proiecte propuse
            </button>
            </li>
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "membri" ? "active" : ""}`}
                onClick={() => setActiveTab("membri")}
            >
                Puncte Membri
            </button>
            </li>
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "status" ? "active" : ""}`}
                onClick={() => setActiveTab("status")}
            >
                Modificare status membru
            </button>
            </li>
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "eveniment" ? "active" : ""}`}
                onClick={() => setActiveTab("eveniment")}
            >
                Creează eveniment
            </button>
            </li>
            <li className="nav-item">
            <button
                className={`nav-link ${activeTab === "cursuri" ? "active" : ""}`}
                onClick={() => setActiveTab("cursuri")}
            >
                Creează cursuri
            </button>
            <button
                className={`nav-link ${activeTab === "editeazaCursuri" ? "active" : ""}`}
                onClick={() => setActiveTab("editeazaCursuri")}
            >
                Editează cursuri
            </button>
            </li>
        </ul>

        {/* Conținut dinamic */}
        <div className="mt-4">{renderContent()}</div>
        </div>
    </>   
  );
}
